export function filterCommunityPosts(posts, { search = '', type = 'all', pillar = 'all', sort = 'recent' } = {}) {
  if (!Array.isArray(posts)) return [];

  let filtered = [...posts];

  if (type !== 'all') {
    filtered = filtered.filter((post) => post.type === type);
  }

  if (pillar !== 'all') {
    filtered = filtered.filter((post) => post.category === pillar);
  }

  const query = search.trim().toLowerCase();
  if (query) {
    filtered = filtered.filter(
      (post) =>
        post.title?.toLowerCase().includes(query) ||
        post.description?.toLowerCase().includes(query) ||
        post.author?.toLowerCase().includes(query)
    );
  }

  if (sort === 'top') {
    filtered.sort((a, b) => (b.likes || 0) - (a.likes || 0));
  } else {
    filtered.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  }

  return filtered;
}

export function filterCommunityMembers(members, search = '') {
  const query = search.trim().toLowerCase();
  if (!query) return members;

  return members.filter((member) => {
    const displayName =
      member.firstName && member.lastName
        ? `${member.firstName} ${member.lastName}`.trim()
        : member.displayName || member.email?.split('@')[0] || 'Client';

    return (
      displayName.toLowerCase().includes(query) ||
      member.email?.toLowerCase().includes(query) ||
      member.company?.toLowerCase().includes(query)
    );
  });
}
